var ctr_cerca; 


function filterJSON(rawjson) {

	//var jsonData = JSON.parse(rawjson);
		var jsonData = rawjson;

	// Ara la resposta és GeoJSON
	// Els resultats estan a jsonData.features
	var sortedResults = jsonData.features || [];

	var json = {},
		key, loc, disp = [];
/*
	// Ordenació igual que abans
	sortedResults.sort(function compare(a, b) {

		var aProps = a.properties || {};
		var bProps = b.properties || {};

		if (undefined === aProps.source || undefined === bProps.source)
			return 0;

		if ("PELIAS" == aProps.source && "ICGC" == bProps.source) {
			return -1;
		}
		if ("PELIAS" == bProps.source && "ICGC" == aProps.source) {
			return 1;
		}

		return 0;
	});
	*/

	if (sortedResults.length > 1) {

		for (var i = 0; i < sortedResults.length; i++) {

			var feature = sortedResults[i];
			var props = feature.properties || {};
			var geometria = feature.geometry;

			var nom = props.etiqueta;
			var origen ="ICGC"; //props.origen;

			if (origen !== undefined && origen !== "undefined") {
				nom = nom + " <i>(" + origen + ")</i>";
			}

			// ICGC
			if (origen === "ICGC") {

				if (geometria && geometria.type === "Point") {
					var coords = geometria.coordinates;
					json[nom] = L.latLng(coords[1], coords[0]);
				}
			}

			// Dades del mapa
			else if (origen === "Dades del mapa") {

				var nameAll = JSON.stringify(props.nom);
				var businessIdVis = props.businessidVis;

				var name = nameAll;
				(name.length > 30) ? name = name.substring(0, 30) + "..." : name;

				if (geometria !== undefined) {

					// POINT
					if (geometria.type === "Point") {

						var coordsSplit = geometria.coordinates;

						json[name + " <i>(" + origen + ")</i>"] =
							L.latLng(coordsSplit[1], coordsSplit[0]) +
							"#tooltip=" + nameAll +
							"#businessIdVis=" + businessIdVis;
					}

					// LINESTRING
					else if (geometria.type === "LineString") {

						var geom = L.GeoJSON.coordsToLatLngs(geometria.coordinates);
						var line = L.polyline(geom);

						json[name + " <i>(" + origen + ")</i>"] =
							JSON.stringify(line._bounds) +
							"#tooltip=" + nameAll +
							"&businessIdVis=" + businessIdVis;
					}

					// POLYGON
					else if (geometria.type === "Polygon") {

						var geom = L.GeoJSON.coordsToLatLngs(geometria.coordinates);
						var pol = L.polygon(geom);

						json[name + " <i>(" + origen + ")</i>"] =
							JSON.stringify(pol._bounds) +
							"#tooltip=" + nameAll +
							"&businessIdVis=" + businessIdVis;
					}
				}
			}

			// Altres orígens
			else {

				if (geometria && geometria.type === "Point") {
					var coords = geometria.coordinates;
					json[nom] = L.latLng(coords[1], coords[0]);
				}
			}
		}
	}
	else {

		if (sortedResults.length > 0) {

			var feature = sortedResults[0];
			var props = feature.properties || {};
			var geometria = feature.geometry;

			var nom = props.nom;
			var origen = props.origen;

			if (origen !== undefined && origen !== "undefined") {
				nom = nom + " <i>(" + origen + ")</i>";
			}

			// ICGC
			if (origen === "ICGC") {

				if (geometria && geometria.type === "Point") {

					var coords = geometria.coordinates;
					json[nom] = L.latLng(coords[1], coords[0]);
				}
			}

			// Dades del mapa
			else if (origen === "Dades del mapa") {

				var name = JSON.stringify(props.nom);

				(name.length > 30)
					? name = name.substring(0, 30) + "..."
					: name;

				if (geometria !== undefined) {

					// POINT
					if (geometria.type === "Point") {

						var coordsSplit = geometria.coordinates;

						json[name + " <i>(" + origen + ")</i>"] =
							L.latLng(coordsSplit[1], coordsSplit[0]);

						map.setZoom(17);
					}

					// LINESTRING
					else if (geometria.type === "LineString") {

						var geom = L.GeoJSON.coordsToLatLngs(geometria.coordinates);
						var line = L.polyline(geom);

						json[name + " <i>(" + origen + ")</i>"] = line;

						map.fitBounds(line.getBounds());
					}

					// POLYGON
					else if (geometria.type === "Polygon") {

						var geom = L.GeoJSON.coordsToLatLngs(geometria.coordinates);
						var pol = L.polygon(geom);

						json[name + " <i>(" + origen + ")</i>"] = pol;

						map.fitBounds(pol.getBounds());
					}
				}
			}

			// Altres orígens
			else {

				if (geometria && geometria.type === "Point") {

					var coords = geometria.coordinates;
					json[nom] = L.latLng(coords[1], coords[0]);
				}
			}
		}
		else {
			ctr_cerca.showAlert(ctr_cerca.options.textErr);
		}
	}

	return json;
}

function filterJSON2(rawjson) {
	var jsonData = JSON.parse(rawjson.resposta);
	var json = {},
	key, loc, disp = [];
	//console.debug(jsonData);

	var sortedResults = jsonData.resultats;
	sortedResults.sort(
		function compare(a, b) {

			if (undefined === a.source || undefined === b.source)
				return 0;

			if ("PELIAS" == a.source && "ICGC" == b.source) {
				return -1;
			}
			if ("PELIAS" == b.source && "ICGC" == a.source) {
				return 1;
			}

			return 0;
			
		}
	);
	
	if (sortedResults.length>1){
		for (var i = 0; i < sortedResults.length; i++) {
		    var resultat = sortedResults[i];
		
			var nom = resultat.nom;
			var origen = resultat.origen;
			var geometria = resultat.geometria;
			if (origen!==undefined && origen!=="undefined") {
				nom = nom + " <i>("+origen+")</i>";
			}
						
			if (origen==="ICGC") {
				var coordsSplit = resultat.coordenades.split(",");
				json[ nom ] = L.latLng(coordsSplit[1], coordsSplit[0]);
			}
			else if (origen==="Dades del mapa") {
				var nameAll =JSON.stringify( resultat.nom); 
				var businessIdVis = resultat.businessidVis;
				var name= nameAll;
				(name.length > 30)?name=name.substring(0,30)+"...":name;
				if (geometria!==undefined){
                    if (geometria.type==="Point"){
						var coordsSplit = geometria.coordinates;
						json[ name  + " <i>("+origen+")</i>" ] = L.latLng(coordsSplit[1], coordsSplit[0]) +"#tooltip="+nameAll+"#businessIdVis="+businessIdVis;
                    }
                    else if (geometria.type==="LineString"){
                        var geom = L.GeoJSON.coordsToLatLngs(geometria.coordinates);
						var line = L.polyline(geom);
						json[ name  + " <i>("+origen+")</i>"] = JSON.stringify(line._bounds)+"#tooltip="+nameAll+"&businessIdVis="+businessIdVis;
                        //map.fitBounds(line.getBounds());     
                    }
                    else if (geometria.type==="Polygon"){
						var coords=geometria.coordinates;
						var llistaPoligons=[];
						for (var p = 0; p < coords.length; p++){
							var poligons=coords[p];
							var llistaLines=[];
							for (var i = 0; i < poligons.length; i++){
								var lines=poligons[i];
								var llistaPunts=[];
								var punt=new L.LatLng(lines[1], lines[0]);
								llistaPunts.push(punt);								
								llistaLines.push(llistaPunts);
							}
							llistaPoligons.push(llistaLines);
						}
						var pol = L.polygon(llistaPoligons);
						json[name  + " <i>("+origen+")</i>"] = JSON.stringify(pol._bounds)+"#tooltip="+nameAll+"&businessIdVis="+businessIdVis;
                      //  map.fitBounds(pol.getBounds());  
                    }
                }
			}
			else {
				var coordsSplit = resultat.coordenades.split(",");
				json[ nom ] = L.latLng(coordsSplit[0], coordsSplit[1]);
			}
		}
	}
	else {
		if (sortedResults.length>0){
			var coords= sortedResults[0].coordenades;
			var nom = sortedResults[0].nom;
			var origen = sortedResults[0].origen;
			if (origen!==undefined && origen!=="undefined") {
				nom = nom + " <i>("+origen+")</i>";
			}
			var geometria =  sortedResults[0].geometria;
			//console.debug(jsonData);
			var coordsSplit = [];
			if (origen==="ICGC" && coords) {
					coordsSplit = coords.split(",");
					json[ nom ] = L.latLng(coordsSplit[1], coordsSplit[0] );
			}
			else if (origen==="Dades del mapa"){
				var name=JSON.stringify( sortedResults[0].nom);
				(name.length > 30)?name=name.substring(0,30)+"...":name;
				if (geometria!==undefined){
                    if (geometria.type==="Point"){
						var coordsSplit = geometria.coordinates;
						json[ name  + " <i>("+origen+")</i>"] = L.latLng(coordsSplit[1], coordsSplit[0]);
						map.setZoom(17);
                    }
                    else if (geometria.type==="LineString"){
                        var geom = L.GeoJSON.coordsToLatLngs(geometria.coordinates);
						var line = L.polyline(geom);
						json[ name + " <i>("+origen+")</i>" ] = line;
                        map.fitBounds(line.getBounds());     
                    }
                    else if (geometria.type==="Polygon"){
                        var geom = L.GeoJSON.coordsToLatLngs(geometria.coordinates);
						var pol = L.polyline(geom);
						
						json[ name + " <i>("+origen+")</i>"] = pol;
                        map.fitBounds(pol.getBounds());  
                    }
                }
			}
			else if (coords) {
				coordsSplit = coords.split(",");
				json[ nom ] = L.latLng(coordsSplit[0], coordsSplit[1] );
			}
			
		}
		else ctr_cerca.showAlert(ctr_cerca.options.textErr);
	}
	return json;
}


function addControlCercaEdit(){
	

	addHtmlInterficieCerca();


	console.info("ctr",paramUrl.searchAction);

	ctr_cerca=new L.Control.Search({
		url: paramUrl.searchActionPelias+"text={s}"+"&businessId="+url('?businessid'),
		url2: paramUrl.searchAction+"searchInput={s}&text={s}"+"&businessId="+url('?businessid'),
		position:'topcenter',
		filterJSON: filterJSON,
		filterJSON2: filterJSON2,
		animateLocation: false,
		markerLocation: false,
		zoom: 12,
		minLength: 3,
		autoType: false,
		text: window.lang.translate('Cercar topònims ...'),
		idInputText : '#ctr_cerca',
		zoom : 17,
		textSize : 22,
		autoCollapseTime: 3200,
		scope:'mapa',
		textEdit:'<a id="act_end" href="#" >Finaltzar Edicio <span class="glyphicon glyphicon-check"></span></a>'
		
	}).addTo(map);
	
	/*var ctr_cercaNomen = new L.Control.Search({
		url: jsonpurl,
		jsonpParam: jsonpName,
		filterJSON: filterJSONCall,
		animateLocation: false,
		markerLocation: false, //true,
		autoType: true, //false		
		position : 'topcenter',
		propertyName : 'nom',
		markerLocation : false,
		rectangleLocation:false,
		autoCollapse : false,
		botoCerca : true,
		idInputText : '#ctr_cercaNomen',
		zoom : 14,
		initial:false,
		textSize : 22,
		minLength : 1,
		text : window.lang.translate('Cercar llocs mudialment...'),
	});*/
	
//	ctr_cercaNomen.on('search_locationfound', function(e) {
//
//		e.layer.setStyle({fillColor: '#3f0', color: '#0f0'});
//
//		}).on('search_collapsed', function(e) {
//
//		featuresLayer.eachLayer(function(layer) {	//restore feature color
//		featuresLayer.resetStyle(layer);
//		});	
//		});

	//map.addControl(ctr_cercaNomen ); 
	
	jQuery('.search-edit a').on("click", function(e) {	
		var id=jQuery(this).attr('id');
		if(id=="act_move"){

		}else if(id=="act_remove"){
					
		}else if(id=="act_end"){
			
			objEdicio.esticEnEdicio=false;
			featureActive.disable();
			if(crt_Editing){
			crt_Editing.disable();
			}
			jQuery('.search-edit').animate({
				height :'hide'
			});			
		}
	});
	
}


function addHtmlInterficieCerca(){
	
	jQuery('#searchBar').addClass("input-group");
	
	jQuery('#searchBar').append(
	   		   '<div id="ctr_cerca"></div>'			
	);
}
